import { Component, Ref, SimpleEvent, log } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { TabHeader } from '@/components/Tab/TabHeader';

@Component
export class TabContainer extends ThemeComponent {
    @Ref tabHeader!: TabHeader;
    @Ref tabContent !: HTMLDivElement[];

    init() {
        this.$subscribe(this.tabHeader.onTabChange, this.tabChanged.bind(this));
    }

    private tabChanged(tab: string) {
        // Get previously active tab
        const prevActiveButton = this.tabHeader.querySelector('.tab-header__button--active');

        // Check if new tab is not the same as the previously active one
        if (prevActiveButton?.getAttribute('value') !== tab) {

            // Update active classes
            prevActiveButton?.classList.remove('tab-header__button--active');
            this.tabHeader.querySelector(`[value="${tab}"]`)?.classList.add('tab-header__button--active');
        }

        // Get previously active tab content
        const prevActiveContent = this.querySelector('.tab-content--active');

        // Check if new tab content is not the same as the previously active one
        if (prevActiveContent?.getAttribute('name') !== tab) {

            // Update active classes
            prevActiveContent?.classList.remove('tab-content--active');

            for (const content of this.tabContent) {
                if (content.getAttribute('name') === tab) {
                    content.classList.add('tab-content--active');
                    content.classList.remove('visually-hidden');
                } else {
                    content.classList.add('visually-hidden');
                }
            }
        }
    }
}
